import React from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import * as FiIcons from 'react-icons/fi';
const { FiLogOut, FiHome, FiLayout } = FiIcons;
import SafeIcon from '../common/SafeIcon';

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', { 
        method: 'POST',
        credentials: 'include' 
      });
      navigate('/admin/login');
    } catch (err) {
      console.error('Logout failed');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col selection:bg-blue-600 selection:text-white">
      <scrolltoTop />
      
      {/* Admin Top Bar */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-6">
              <Link to="/admin" className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
                  <span className="text-white text-xs font-black">RV</span>
                </div>
                <span className="hidden sm:inline">R. Venue Admin</span>
              </Link>
              
              <nav className="hidden md:flex items-center gap-4">
                <Link to="/admin" className="text-sm font-medium text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md transition">
                  Dashboard
                </Link>
              </nav>
            </div>
            
            <div className="flex items-center gap-4">
              <Link to="/" className="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1 pr-4 border-r border-gray-200">
                <SafeIcon icon={FiHome} />
                <span className="hidden sm:inline">View Site</span>
              </Link>
              <button 
                onClick={handleLogout}
                className="flex items-center gap-2 text-sm font-medium text-red-600 hover:text-red-700 transition"
              >
                <SafeIcon icon={FiLogOut} />
                <span className="hidden sm:inline">Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main className="flex-grow">
        <Outlet />
      </main>
      
      {/* Admin Footer */}
      <footer className="bg-white border-t border-gray-200 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} R. Venue Apartelle Management System. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default AdminLayout;